import React,{useEffect} from 'react'
import { drawBloodPressureChart, drawPPGChart, drawRespoiratoryChart, drawGlucoseChart, drawSpO2Chart, drawTempChart, drawWeightChart } from '@cardiacsense/cs-charts-module'
import { connect, useSelector } from 'react-redux'
import { setSelectedDate } from 'actions'
import { emptyMonthlyData } from 'variables/charts'
import { useWindowSize } from 'hooks/useOnResize'

export function MonthlyChart({patientId, type,thresholds,monthlyData:allMonthsData,setDate,dayStr,unit, statusThresholds}) {
    const monthlyData = allMonthsData?.[patientId]?.[dayStr] || emptyMonthlyData(dayStr)
    const {onLoad} = monthlyData;
    const height = 450;
    const {user} = useSelector((state)=> state)
    const [screenWidth] = useWindowSize();

    const thresholdsStatus = user?.data.appConfigs?.configuration?.alerts?.thresholds || statusThresholds
    const chart = {
        "Pulse Rate": {draw:drawPPGChart, data:[monthlyData[2]]},
        "Respiratory Rate": {draw:drawRespoiratoryChart, data:[monthlyData[3]]},
        "Blood Pressure": {
            draw:drawBloodPressureChart, 
            data:[ monthlyData[4],monthlyData[52],monthlyData[71],monthlyData[5],monthlyData[53],monthlyData[72] ]
        },
        "SpO2": {draw:drawSpO2Chart, data:[ monthlyData[6],monthlyData[54],monthlyData[73] ]},
        "Body Temp": {draw:drawTempChart, data:[ monthlyData[7],monthlyData[55],monthlyData[74] ]},
        "Weight": {draw:drawWeightChart, data:[ monthlyData[29],monthlyData[57] ]},
        "Glucose": {draw:drawGlucoseChart, data:[ monthlyData[30],monthlyData[56] ]}
    }
    
    useEffect(() => {
        if(monthlyData){
            const {draw, data} = chart[type]
            const contentWidth = document.getElementsByClassName("chart-box")[0].clientWidth - 30
            const width = contentWidth > 1180 ? contentWidth : 1190
            const svgNode = draw(...data, thresholds, (date) => setDate(new Date(date)), width,height,unit,thresholdsStatus)
            svgNode.classList.add("d-print-none");
            const chartNode = document.getElementsByClassName(`${type}-chart`)[0]
            chartNode.replaceChild( svgNode, chartNode.firstChild )
            // draw the same chart beat smaller for printing in portal
            const printWidth = 1200
            const printSvgNode = draw(...data, thresholds, (date) => setDate(new Date(date)), printWidth,height,unit,thresholdsStatus)
            printSvgNode.classList.add("print-daily-show");
            chartNode.replaceChild( printSvgNode, chartNode.childNodes[1] );
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [monthlyData, screenWidth])

    return <div className={`${type}-chart`}>
        <div className="svg chart" />
        <object type="image/svg+xml" 
                data={require("../../../assets/img/theme/loading-heart.svg").default } 
                style={{display:onLoad?'initial':'none', width:'20%',position:'absolute',left:'35%',top:'25%',zIndex:2}}>
              loading
        </object>
    </div>

}

const mapStateToProps = ({monthlyData}) => ({monthlyData})
const mapDispatchToProps = {setDate:setSelectedDate}
export default connect(mapStateToProps, mapDispatchToProps)(MonthlyChart)